
import { v4 as uuidv4 } from 'uuid';
import { ElfName } from './types';
import { getCachedPrefixes, getCachedSuffixes, getCachedLastNames, loadNameComponents } from './nameCache';

// Generate a random first name
export const generateFirstName = (): string => {
  loadNameComponents();
  const prefixes = getCachedPrefixes();
  const suffixes = getCachedSuffixes();
  
  const prefix = prefixes[Math.floor(Math.random() * prefixes.length)];
  const suffix = suffixes[Math.floor(Math.random() * suffixes.length)];
  
  return prefix + suffix;
};

// Generate a random last name
export const generateLastName = (): string => {
  loadNameComponents();
  const lastNames = getCachedLastNames();
  
  return lastNames[Math.floor(Math.random() * lastNames.length)];
};

// Generate a complete elf name
export const generateElfName = (includeLastName: boolean): ElfName => {
  const firstName = generateFirstName();
  const lastName = includeLastName ? generateLastName() : undefined;
  
  return {
    id: uuidv4(),
    firstName,
    lastName,
    timestamp: Date.now()
  };
};
